/* unplugin-vue-components disabled */import { render } from "./genrate-popover.vue?vue&type=template&id=453dd86e&scoped=true"
import script from "./genrate-popover.vue?vue&type=script&lang=js"
export * from "./genrate-popover.vue?vue&type=script&lang=js"

import "./genrate-popover.vue?vue&type=style&index=0&id=453dd86e&lang=stylus"
import "./genrate-popover.vue?vue&type=style&index=1&id=453dd86e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453dd86e"],['__file',"src/components/genrate/genrate-popover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "453dd86e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('453dd86e', __exports__)) {
    api.reload('453dd86e', __exports__)
  }
  
  module.hot.accept("./genrate-popover.vue?vue&type=template&id=453dd86e&scoped=true", () => {
    api.rerender('453dd86e', render)
  })

}


export default __exports__